export var FTTB_PAGE_PREFIX = 'FTTB2022';
export var IS_BACK_CALL_POPUP_SHOWN = 'backCallPopupIsShown';
export var ERROR_TYPES = {
  cancel: 'cancel',
  emptyAddress: 'empty_address',
  noAlternativeTariff: 'noAlternativeTariff'
};
export var ADDRESS_PARAMS_DATA = 'address_params_data';